<template>
  <v-row class="text--primary" v-if="showUltimasCompras">
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Últimas compras
        </v-subheader>
        <v-divider/>
        <px-ultimas-compras-produto-table :produto="itemAprovacao.produto"/>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import UltimasComprasProdutoTable
  from '@/modules/compra/compra-produtos/UltimasComprasProdutoTable.vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    itemAprovacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleAprovadorRequisicao', 'hasRoleAprovador']),
    showUltimasCompras() {
      return this.hasRoleComprador
        || this.hasRoleAprovadorRequisicao || this.hasRoleAprovador;
    },
  },
  components: {
    pxUltimasComprasProdutoTable: UltimasComprasProdutoTable,
  },
};
</script>
